module.exports = __webpack_public_path__ + "img/menu_titulo.4383b74e.png";